export default {
  methods: {
    getMaxFileUpload() {
      return Variable.MAX_FILE_UPLOAD;
    },
    getMaxFileUploadAsMB() {
      return this.getMaxFileUpload() / 1000000;
    },
  },
};

export const Variable = Object.freeze({
  MAX_FILE_UPLOAD: 20000000,
});
